export default [
	{
		href: '/missions/list',
		name: 'List',
		permission: null
	},
	{
		href: '/achievements/list',
		name: 'Achievement',
		permission: null
	}
];


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/missions/tabs.js